const WaitButtonBehavior = require('./waitButtonBehavior'),
    LockFormBehavior = require('./lockFormBehavior'),
    HandleServerValidationErrorBehavior = require('./handleServerValidationBehavior'),
    AutoFocusBehavior = require('./autoFocusBehavior'),
    ManageTagSettingsBehavior = require('./manageTagSettingsBehavior'),
    SaveModelBehavior = require('./saveModelBehavior'),
    CustomTemplateBindingBehavior = require('./customTemplateBindingBehavior'),
    ForceSelect2PlaceholderBehavior = require('./forceSelect2PlaceholderBehavior'),
    InputMaskBehavior = require('./inputMaskBehavior'),
    PersistentViewModelBehavior = require('./persistentViewModelBehavior');

module.exports = {
    WaitButton: WaitButtonBehavior,
    LockForm: LockFormBehavior,
    HandleServerValidationError: HandleServerValidationErrorBehavior,
    AutoFocus: AutoFocusBehavior,
    ManageTagSettings: ManageTagSettingsBehavior,
    SaveModel: SaveModelBehavior,
    CustomTemplateBinding: CustomTemplateBindingBehavior,
    ForceSelect2Placeholder: ForceSelect2PlaceholderBehavior,
    InputMask: InputMaskBehavior,
    PersistentViewModel: PersistentViewModelBehavior
};